export default __webpack_public_path__ + "static/media/Christaphor-Harmandarian-resume.874258c8.pdf";